
import { Component, Prop } from 'vue-property-decorator';
import Page from '@/Page.vue';
import { TooltipState } from '@/libs/tpm-analytics/core/gantt-timeline.types';
import { PlanItemBasicModel } from '@/libs/Api';
import moment from 'moment';

@Component
export default class GanttTooltip extends Page {
    @Prop({ required: true }) state!: TooltipState;

    get planItem(): PlanItemBasicModel {
        return (this.state.event?.planItem || {}) as PlanItemBasicModel;
    }

    /**
     * Formátování data a času
     */
    formatDateTime(date: Date): string {
        return moment(date).format('DD.MM.YYYY HH:mm');
    }

    /**
     * Formátování trvání
     */
    formatDuration(from: Date, to: Date | null): string {
        const end = to || new Date();
        const durationMs = end.getTime() - from.getTime();
        const hours = Math.floor(durationMs / (1000 * 60 * 60));
        const minutes = Math.floor((durationMs % (1000 * 60 * 60)) / (1000 * 60));

        if (hours > 0) {
            return `${hours}h ${minutes}min`;
        }
        return `${minutes}min`;
    }

    /**
     * Formátování měny
     */
    formatCurrency(value: number): string {
        return new Intl.NumberFormat('cs-CZ', {
            style: 'currency',
            currency: 'CZK',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value);
    }
}
